export const locale = {
    lang: 'cs',
    data: {
        NAV: {
            APPLICATIONS: 'Programlar',
            SAMPLE: {
                TITLE: 'Örnek',
                BADGE: '15'
            }
        }
    }
};
